import type { AttendeeFields, RsvpSubmission, SpouseRsvp } from '@mr-website/schemas';
import type { GuestRow } from './GuestSection';
import type { SpouseFormState } from './SpouseSection';
import type { LinkedSpouse } from './types';

export function toAttendeePayload(attendee: AttendeeFields): AttendeeFields {
  return {
    first_name: attendee.first_name.trim(),
    last_name: attendee.last_name.trim(),
    send_invite: attendee.send_invite,
    email: attendee.send_invite ? attendee.email?.trim() : undefined,
  };
}

/**
 * Maps the spouse form state to the RSVP spouse payload.
 * The spouse CRM contact must already exist — create it via POST /profile/spouse
 * before building the submission when the member has no linked spouse on file.
 */
export function toSpousePayload(
  linkedSpouse: LinkedSpouse | null,
  spouse: SpouseFormState,
): SpouseRsvp | undefined {
  if (!spouse.enabled) return undefined;

  const contactId = linkedSpouse?.contact_id?.trim();
  if (!contactId || !linkedSpouse) {
    throw new Error('Your spouse could not be linked. Please contact your advisor.');
  }

  return {
    contact_id: contactId,
    first_name: linkedSpouse.first_name.trim(),
    last_name: linkedSpouse.last_name.trim(),
    send_invite: spouse.fields.send_invite,
    email: linkedSpouse.email?.trim(),
  };
}

export function buildRsvpSubmission(
  linkedSpouse: LinkedSpouse | null,
  spouse: SpouseFormState,
  guests: GuestRow[],
): RsvpSubmission {
  return {
    spouse: toSpousePayload(linkedSpouse, spouse),
    guests: guests.map(toAttendeePayload),
  };
}
